import { API_ROUTES } from '@/constants/apiRoutes';
import { PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { StoreOwner, StoreOwnerListParams } from './storeOwner.types';

const getStoreOwnersList = (client: AxiosInstance) => async (params?: StoreOwnerListParams) => {
  return (await client.get<PaginatedApiResponse<StoreOwner[]>>(API_ROUTES.GET_STORE_OWNER_LIST, { params })).data;
};

export const storeOwnerQueries = {
  all: () => ['store-owners'],
  list: (params?: StoreOwnerListParams) =>
    queryFactoryOptions<PaginatedApiResponse<StoreOwner[]>>({
      queryKey: [...storeOwnerQueries.all(), 'list', params],
      queryFn: (client: AxiosInstance) => () => getStoreOwnersList(client)(params),
    }),
  owner: () =>
    queryFactoryOptions({
      queryKey: [...storeOwnerQueries.all()],
      queryFn: (client: AxiosInstance) => () => getStoreOwnersList(client)(),
    }),
};
